// WP4 daily screens. English counterpart of dailyApp.nl.ts.
export const appDailyEn = {
    stars: {
        tab: 'Stars',
        approvals: 'Approve',
        approvalsEmpty: 'Nothing to approve.',
        handled: 'Handled',
        rewards: 'Rewards',
        savingFor: 'Saving for {goal}',
        noGoal: 'No savings goal yet',
        goalLabel: 'Savings goal for {name}',
        adjustLabel: 'Adjust points for {name}',
        history: 'Latest points for {name}',
        info: 'Children earn stars with tasks. Here you see per child what they can spend, what they are saving for and what still needs approval. Add or change a reward under Rewards.',
    },
    agenda: {
        title: 'Calendar',
        rides: 'Rides',
        tools: 'More for the calendar',
        toolsTitle: 'Calendar',
        calendars: 'Connect calendars',
        calendarsHint: 'Show events from Google, Outlook or iCloud here.',
        exportHint: 'All events as a calendar file (.ics).',
        trashHint: 'Restore deleted events for 30 days.',
    },
    pinboard: {
        title: 'Pinboard',
        label: 'Parts of the pinboard',
        notes: 'Notes',
        messages: 'Messages',
        wishes: 'Wishes',
    },
    kids: {
        title: 'Children',
        label: 'Parts for the children',
        learning: 'Learning goals',
        growth: 'Growth',
        school: 'School',
        filter: 'Choose a child',
        all: 'All children',
    },
    chores: {
        label: 'Kind of tasks',
        series: 'Routine tasks',
        chores: 'Chores',
    },
    recipes: {
        more: 'Load more',
        shown: '{shown} of {total}',
        pick: 'Choose a recipe from the list.',
        filter: 'Which recipes',
    },
    menu: {
        past: {
            one: '{count} day earlier this week',
            other: '{count} days earlier this week',
        },
        showPast: 'Show',
        hidePast: 'Hide',
        suggestions: 'Suggestions',
        suggestionsCount: 'Suggestions ({count})',
        shelfHint: 'Drag a recipe onto a day.',
    },
};
//# sourceMappingURL=dailyApp.en.js.map